import { getData, postData } from "@/utils/http";
import config from "@/config"
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],
		name: "",
		phone: "",

		pageIndex: 1,
		total: 0,
		activeTab: 'inner',
		deptId: "",

	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading;
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading;
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows;
			state.total = changeData.total;
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item;
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData["changeKey"] == "orgId" && typeof changeData["data"] != "object") {
				state[changeData["changeKey"]] = [changeData["data"]];
			} else {
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value;
		}
	},
	actions: {
		//获取列表
		getList({ commit, state },deptId) {
			return new Promise((resolve) => {
				getData(`logistics/driver/time/page?name=${state.name}&phone=${state.phone}&page=${state.pageIndex}&size=${config.pageSize}&deptId=${deptId}`).then((res) => {
					if (res.state == 1) {
						var exData = {};
						for (var i = 0; i < res.data.rows.length; i++) {
							exData = {};
							for (var j = 0; j < res.data.rows[i]['extendData'].length; j++) {
								exData[`${res.data.rows[i]['extendData'][j]['key']}`] = res.data.rows[i]['extendData'][j];
							}
							res.data.rows[i]['extendDataView'] = exData;

						}
						commit("CHANGE_TABLE_DATA", res);
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},
		//获取车辆类型
		getCarTypeList({ commit, state }) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dict/data/type/car_type`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},

		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit("CHANGE_SEARCH_COLL", changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit("CHANGE_TABLE_INDEX", value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit("CHANGE_ADD_LOADING", value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit("CHANGE_TABLE_LOADING", value)
		}
	}
}
